import { Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Form, Input, FormGroup, FormFeedback, Spinner } from 'reactstrap';
import { Button } from '../form';
import { useEffect, useState } from 'react';

export const FreePassForm = ({
  values,
  isSubmitting,
  handleSubmit,
  handleChange,
  errors = {},
  status,
  setStatus,
}) => {
  const [isInvalid, setIsInvalid] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (errors.freePassCode) {
      setIsInvalid(true);
      setError(errors.freePassCode);
      setTimeout(function () {
        setError(false);
        setIsInvalid(false);
      }, 5000);
    }
    if (status.apiErrorCode) {
      setIsInvalid(true);
      setError(status.apiErrorCode);
      setTimeout(function () {
        setError(false);
        setIsInvalid(false);
        setStatus({});
      }, 5000);
    }
  }, [errors.freePassCode, status, isSubmitting]); // eslint-disable-line

  return (
    <div className='CouponCode'>
      <Box>
        <h3 className='text-white fs-5 mb-4'>
          <FormattedMessage id='FreePassForm.form.freePassCode.title' />
        </h3>
      </Box>
      <Form onSubmit={handleSubmit} style={{ position: 'relative' }}>
        <FormGroup>
          <FormFeedback tooltip>{error}</FormFeedback>
          <div style={{ display: 'flex' }}>
            <Input
              invalid={!!isInvalid}
              id='freePassCode'
              name='freePassCode'
              placeholder={'Cupón'}
              className='couponInput'
              value={values.freePassCode}
              onChange={handleChange}
              bsSize='small'
              disabled={false}
            />
            <FormFeedback tooltip style={{ top: '77% !important' }}>
              {error}
            </FormFeedback>
            <Button type='submit' className='CouponCode_button_apply'>
              {isSubmitting ? (
                <Spinner className='CouponCode_button_spinner' />
              ) : (
                <FormattedMessage id='FreePassForm.form.button.apply' />
              )}
            </Button>
          </div>
        </FormGroup>
      </Form>
    </div>
  );
};
